import apiPaths from '../api-paths';

export default {
  showByParent() {
    return axios.get(`${ apiPaths.UPSTREAM.CRM }/by-parent`);
  },
};
